import styled from "styled-components"

export const Cardwrapper = styled.div`
background-color: #ffffff;
width: 90%;
display: flex;
flex-direction: column;
border-radius: 4px;
box-shadow: rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px;
padding: 10px;
margin: 5px;
`;
export const CardName = styled.div`
display: flex;
// background-color: green;
align-items: center;
margin-bottom: 5px;
`;
export const CardAvatar = styled.div`
// background-color: #0E8FD8;
height: 20px;
width: 20px;
border-radius: 100px;
margin-right: 5px;
`;
export const CardPoster = styled.div`
font-weight: 500;
color: #0E8FD8;
font-size: 14px;
display: flex;
`;
export const CardInfo = styled.div`
color: #505050;
font-size: 12px;
margin-bottom: 5px;
line-height: 17px;
`;
export const CardResponse = styled.div`
display: flex;
justify-content: right;
// background-color: green;
`;
export const SizeIt = styled.div`
display: flex;
align-items: center;
margin-right: 3px;
`;
export const Text = styled.div`
// background-color: brown;
display: flex;
align-items: center;
font-size: 10px;
color: #0E8FD8;
`;
// export const SizeIt = styled.div``;
// export const Cardwrapper = styled.div``;